<k-area-blocker [showLoader]="_isBusy" [message]="_blockerMessage" [bodyScroll]="true">
  <div class="kEntries kOverrideFAIcons">
    <div #entriesTableHolder class="kEntriesHolder kContent">
      <kSticky stickyId="entriesFilters" [scrollOffset]="80" [sticksTo]="'header'">
        <div class="kEntriesTableFilters kContent" [class.kAdditionalFilters]="additionalFilters.children.length !== 0">
          <span
            class="kSelectedEntriesNum"
            *ngIf="(_entriesStore.entries.data$ | async)?.totalCount && additionalFilters.children.length === 0"
          >
            {{
              'applications.content.entries.entries' | translate: [(_entriesStore.entries.data$ | async)?.totalCount]
            }}
          </span>

          <div [class.kHidden]="!selectedEntries.length" class="kBulkOperations">
            <span *ngIf="bulkWrapper.children.length !== 0" class="kSelectedEntriesLabel">
              • {{ selectedEntries.length }} {{ 'applications.content.entries.selected' | translate }}
            </span>
            <div #bulkWrapper>
              <ng-content select=".bulk-actions"></ng-content>
            </div>

            <a *ngIf="bulkWrapper.children.length !== 0" class="kBulkCancel" (click)="clearSelection()">{{
              'applications.content.entries.cancel' | translate
            }}</a>
          </div>
          <div
            class="kFiltersWrapper"
            [class.kHidden]="additionalFilters.children.length === 0 && selectedEntries.length"
          >
            <div #additionalFilters>
              <ng-content select=".additional-filters"></ng-content>
            </div>

            <div class="kFilters">
              <div class="searchHolder">
                <input
                  type="text"
                  pInputText
                  class="kSearchInput"
                  [(ngModel)]="_query.freetext"
                  (keyup.enter)="onFreetextChanged()"
                  placeholder="{{ 'applications.content.entries.searchEntries' | translate }}"
                />
                <i
                  class="kIconsettings-solid dropdown"
                  [class.kSelected]="entriesSearchFilter.selectedSearchField !== 'all'"
                  #searchHolder
                  [kTooltip]="searchFieldsTooltip"
                ></i>
              </div>
              <div #categoriesFilterBtn class="kCategoriesFilter kDropdown">
                <i class="kIconfolder" *ngIf="!_categoriesUpdating"></i>
                <div
                  *ngIf="_categoriesUpdating"
                  class="k-spinner-background kSpinnerBkg"
                  kTooltip="{{ 'applications.content.categories.categoriesUpdateMsg' | translate }}"
                >
                  <div class="k-spinner-animation kSpinnerAnim"></div>
                </div>
                <span>{{ 'applications.content.entries.filterCategories' | translate }}</span>
                <i class="kIcondropdown_arrow_bottom dropdown"></i>
              </div>
              <div #refineBtn class="kRefine kDropdown">
                <i class="kIconfilter"></i>
                <span>{{ 'applications.content.entries.refine' | translate }}</span>
                <i class="kIcondropdown_arrow_bottom dropdown"></i>
              </div>
            </div>
          </div>
          <button
            *ngIf="showReload"
            pButton
            class="kButtonDefault kRefreshBtn small"
            type="text"
            icon="kIconrefresh"
            [kTooltip]="'applications.content.entries.refresh' | translate"
            (click)="_reload()"
          ></button>
        </div>
        <span
          class="kEntriesInfo"
          *ngIf="additionalFilters.children.length !== 0 && !(_entriesStore.entries.state$ | async)?.loading"
        >
          <span *ngIf="(_entriesStore.entries.data$ | async)?.totalCount">
            {{
              'applications.content.entries.entries' | translate: [(_entriesStore.entries.data$ | async)?.totalCount]
            }},
            {{ 'applications.content.entries.totalDuration' | translate: [_entriesDuration | kTime] }}
          </span>
          <span *ngIf="!(_entriesStore.entries.data$ | async)?.totalCount">
            {{ 'applications.content.entries.noEntries' | translate }}
          </span>
        </span>
      </kSticky>
      <kSticky #tags [stickyClass]="'kStickyClass'" stickyId="entriesTags" [sticksTo]="'entriesFilters'">
        <div class="kContent">
          <k-entries-list-tags
            [showEnforcedFilters]="showEnforcedFilters"
            [refineFilters]="_refineFilters"
            [enforcedFilters]="enforcedFilters"
            (onTagsBarVisible)="_isTagsBarVisible = $event"
            (onClearAll)="onClearAllTags()"
            (onTagsChange)="onTagsChange()"
          ></k-entries-list-tags>
        </div>
      </kSticky>

      <k-area-blocker [showLoader]="_tableIsBusy" [message]="_tableBlockerMessage" [bodyScroll]="true">
        <kEntriesTable
          class="kEntriesTable"
          scrollHeight="100%"
          [isTagsBarVisible]="_isTagsBarVisible"
          [entries]="(_entriesStore.entries.data$ | async)?.items"
          [showBulkSelect]="bulkWrapper.children.length !== 0"
          [sortField]="_query.sortBy"
          [sortOrder]="_query.sortDirection"
          [columns]="columns"
          [rowActions]="rowActions"
          (actionSelected)="onActionsSelected.emit($event)"
          (openActionsMenu)="_openActionsMenu($event)"
          (sortChanged)="onSortChanged($event)"
          [(selectedEntries)]="selectedEntries"
        ></kEntriesTable>
      </k-area-blocker>

      <div class="kEntriesTableFooter kContent" #footer *ngIf="(_entriesStore.entries.data$ | async)?.totalCount">
        <p-paginator
          [rows]="_query.pageSize"
          [first]="_query.pageIndex * _query.pageSize"
          [totalRecords]="(_entriesStore.entries.data$ | async)?.totalCount | kMaxEntries"
          [rowsPerPageOptions]="[25, 50, 100, 250]"
          (onPageChange)="onPaginationChanged($event)"
        ></p-paginator>
        <span class="kPaginatorShowRowsLabel">{{ 'applications.content.paginator.showRows' | translate }}</span>
      </div>
    </div>
  </div>
</k-area-blocker>

<p-menu #actionsmenu [popup]="true" [model]="_items" [appendTo]="'body'" kMenuCloseOnScroll></p-menu>

<!-- popup widgets section -->
<kPopupWidget
  #categoriesFilterPopup
  data-aid="categoriesFilterPopup"
  [popupWidth]="400"
  [popupHeight]="500"
  placement="top"
  [closeBtn]="false"
  [targetRef]="categoriesFilterBtn"
  [targetOffset]="{ x: -10, y: -21 }"
  kSticky
  [sticksTo]="'header'"
  [stickyClass]="'kForceFix'"
  [stickyId]="'categoriesFilterPopup'"
  [scrollOffset]="80"
>
  <ng-template>
    <kCategoriesFilter
      [parentPopupWidget]="categoriesFilterPopup"
      [selection]="_query.categories"
      [selectionMode]="_query.categoriesMode"
      (onCategorySelected)="onCategorySelected($event)"
      (onCategoriesUnselected)="onCategoriesUnselected($event)"
      (selectionModeChange)="onCategoriesModeChanged($event)"
    ></kCategoriesFilter>
  </ng-template>
</kPopupWidget>

<kPopupWidget
  #refinePopup
  data-aid="entriesRefinePopup"
  [popupWidth]="400"
  [popupHeight]="500"
  placement="top"
  [closeBtn]="false"
  [targetRef]="refineBtn"
  [targetOffset]="{ x: -200, y: -15 }"
  kSticky
  [sticksTo]="'header'"
  [stickyClass]="'kForceFix'"
  [stickyId]="'refinePopup'"
  [scrollOffset]="80"
>
  <ng-template>
    <k-entries-refine-filters
      [refineFilters]="_refineFilters"
      [showEnforcedFilters]="showEnforcedFilters"
      [enforcedFilters]="enforcedFilters"
      [parentPopupWidget]="refinePopup"
    ></k-entries-refine-filters>
  </ng-template>
</kPopupWidget>

<kPopupWidget
  #searchPopup
  data-aid="entriesSearchPopup"
  [popupWidth]="250"
  [popupHeight]="350"
  placement="top"
  [closeBtn]="false"
  [targetRef]="searchHolder"
  [targetOffset]="{ x: -223, y: 32 }"
  kSticky
  [sticksTo]="'header'"
  [stickyClass]="'kForceFix'"
  [stickyId]="'searchPopup'"
  [scrollOffset]="80"
>
  <k-entries-search-filters
    #entriesSearchFilter
    [parentPopupWidget]="searchPopup"
    (searchFieldSelected)="applySearchFields($event)"
  ></k-entries-search-filters>
</kPopupWidget>
